var map = {
	"./image-carousel.de-CH.json": 1469,
	"./image-carousel.de-DE.json": 1470,
	"./image-carousel.en-CA.json": 1471,
	"./image-carousel.en-GB.json": 1472,
	"./image-carousel.en-IN.json": 1473,
	"./image-carousel.en-ME.json": 1474,
	"./image-carousel.en-US.json": 1475,
	"./image-carousel.es-EM.json": 1476,
	"./image-carousel.es-ES.json": 1477,
	"./image-carousel.fr-BE.json": 1478,
	"./image-carousel.fr-CA.json": 1479,
	"./image-carousel.fr-CH.json": 1480,
	"./image-carousel.nl-BE.json": 1481,
	"./image-carousel.nl-NL.json": 1482,
	"./image-carousel.pl-PL.json": 1483,
	"./image-carousel.pt-BR.json": 1484
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1468;